import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";

// Cada deploy cloud inyecta un release id distinto. Además de dejarlo visible
// para diagnóstico, fuerza un hash nuevo del bundle y evita que una respuesta
// SPA transitoria cacheada bajo /assets/*.js deje la app en blanco.
const releaseId = import.meta.env.VITE_RELEASE_ID;
if (releaseId) document.documentElement.dataset.nexoRelease = releaseId;

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
